module.exports = __webpack_public_path__ + "img/натютморт со старинными книгами 110х90.dd932413.jpg";